import '../App.css';
import MainContent from '../components/MainContent';
import { MouseEventHandler, useRef, useState, useEffect } from 'react';
import { BackButton, BackgroundStyle, BigHeading, ButtonContainer, DocumentButton, LabelContainer, LightBlueContainer, ShortBlueButton } from '../assets/style';
import SearchInput from '../components/SearchInput';
import dayjs from 'dayjs';
import SearchDatePicker from '../components/SearchDatePicker';
import FormButton from '../components/FormButton';
import { Box, FormControl, IconButton, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { deleteIcon } from '../assets/imgs';
import axios from 'axios';
import FormInput from '../components/FormInput';
import FormDatePicker from '../components/FormDatePicker';
import React from 'react';
import FormLabel from '../components/FormLabel';
import { height, minWidth } from '@mui/system';
import FormCheckbox from '../components/FormCheckbox';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import { companyPageName, projectPageName } from '../components/PageName';
import { useCreateProjectMutation, useLazyGetProjectByIdQuery, useUpdateProjectMutation } from '../features/project/projectSlice';
import FormDropDownList from '../components/FormDropDownList';
import { useLazyGetContractDDLQuery } from '../features/contract/ContractSlice';
import { ContractItemModel } from '../models/ContractItemModel';
import ModalConfirmationBox from '../components/ModalConfirmationBox';
import { useCreateCompanyMutation, useLazyGetCompanyByIdQuery, useUpdateCompanyMutation } from '../features/comapny/comapnySlice';
import { useTranslation } from "react-i18next";

const AddCompanyPage = () => {
    const navigate = useNavigate();
    const getLocation = useLocation();
    var company = getLocation?.state;
    const [getCompanyQuery] = useLazyGetCompanyByIdQuery();
    const [createCompany] = useCreateCompanyMutation();
    const [updateCompany] = useUpdateCompanyMutation();
    const [name, setName] = useState("");
    const [isActive, setIsActive] = useState(true);

    const [openConfirmationBox, setOpenConfirmationBox] = useState(false)
    const {t, i18n} = useTranslation();

    useEffect(() => {
        handleCompanyData();
    }, []);

    const handleCompanyData = async () => {
        try {
            if (localStorage.accessToken) {
                getCompanyQuery(company?.id)
                    .then((respone) => {
                        if (respone.status == 'fulfilled') {
                            setName(respone?.data?.name)
                            setIsActive(respone?.data?.isActive)
                        }
                    })
            }
        } catch (error) {
            setOpenConfirmationBox(false);
            alert('An error occurred. Please refresh (F5) or login again.');
            console.log(error);
        } finally {
            // Code to execute after the try-catch block, regardless of success or failure
        }
    };

    const handleCreateCompany = async () => {
        try {
            if (localStorage.accessToken) {

                company = {
                    // id: "",
                    name: name?.toString(),
                    isActive: isActive?.toString(),
                }
                createCompany(company)
                    .then((res) => {
                        if ('error' in res) {
                            console.log(res.error);
                            alert(`Create Company failed: ${res.error}`)
                            setOpenConfirmationBox(false);
                        }
                        else {
                            console.log(res?.data);
                            alert("Create Company Success")
                            setOpenConfirmationBox(false);
                            navigate('/company-detail', { state: res?.data })
                        }
                    })
            }
        }
        catch (error) {
            alert('An error occurred. Please refresh (F5) or login again.');
            console.log(error)
        } finally {
        }
    }
    const onCloseConfirmationBox = function () {
        setOpenConfirmationBox(false)
    }

    const onOpenConfirmationBox = function () {
        setOpenConfirmationBox(true)
    }

    const handleUpdateCompany = async () => {

        try {
            console.log("getting data")
            if (localStorage.accessToken) {

                company = {
                    id: company?.id,
                    name: name?.toString(),
                    // isActive: isActive?.toString(),

                }
                updateCompany(company).then((res) => {
                    if ('error' in res) {
                        console.log(res.error);
                        alert(`Update failed: ${res.error}`)
                        setOpenConfirmationBox(false);
                    }
                    else {
                        console.log("Update Success ", res?.data);
                        alert("Update Success")
                        setOpenConfirmationBox(false);
                        navigate('/company-detail', { state: res?.data });
                    }
                })
            };
        } catch (error) {
            alert('An error occurred. Please refresh (F5) or login again.');
            console.log(error)
        } finally {
        }
    }

    const handleContractNumChange = (e: any) => {
        setIsActive(!isActive)
    };

    return (
        <MainContent type={companyPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <LightBlueContainer>
                    {!company && <BigHeading>{t("Add New Company")}</BigHeading>}
                    {company && <BigHeading>{t("Edit Company Detail")}</BigHeading>}

                    <FormInput title={t("Company Name")} value={name} setMethod={setName} />
                    {/* <FormInput title={"Is Active"} value={isActive} setMethod={setIsActive} /> */}
                    {company && <FormDropDownList
                        sameRowTitle={"Is Active"}
                        value={isActive}
                        handleValueChange={handleContractNumChange}
                        items={['true', 'false']}
                    />}
                    &nbsp;
                    <Box sx={{ display: "row" }}>
                        <ShortBlueButton onClick={onOpenConfirmationBox}>{t("Save")}</ShortBlueButton>
                        {!company && <BackButton onClick={() => { navigate('/company') }}>{t("Back")}</BackButton>}
                        {company && <BackButton onClick={() => { navigate(`/company-detail`, { state: company }); }}>{t("Back")}</BackButton>}
                    </Box>
                    &nbsp;
                </LightBlueContainer>
            </BackgroundStyle>
            <ModalConfirmationBox description={company ? t("Are you sure to update this company?") : t("Are you sure to add new company?")} open={openConfirmationBox} onClose={onCloseConfirmationBox} onConfirm={company ? handleUpdateCompany : handleCreateCompany} />
        </MainContent>
    );
};

export default AddCompanyPage;